// VerticalStepper.jsx
import React from "react";

const defaultSteps = [
  "Setup email",
  "Setup phone number",
  "Identity verification",
  "Address information",
  "Additional information",
  "Add next of kin",
  "Finish",
];

const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-3.5 h-3.5"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 00-1.414 0L7.5 13.086 4.707 10.293a1 1 0 10-1.414 1.414l3.5 3.5a1 1 0 001.414 0l8.5-8.5a1 1 0 000-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

export default function VerticalStepper({ step = 1, steps = defaultSteps }) {
  // clamp step
  const current = Math.max(1, Math.min(step, steps.length));

  return (
    <nav aria-label="Progress" className="flex flex-col items-start">
      {steps.map((label, index) => {
        const idx = index + 1;
        const completed = current > idx;
        const active = current === idx;
        const isLast = index === steps.length - 1;

        return (
          <div key={label} className="flex items-start w-full">
            {/* left column: circle + connector */}
            <div className="flex flex-col items-center mr-3">
              {/* circle */}
              <div
                aria-current={active ? "step" : undefined}
                className={
                  "flex items-center justify-center w-5 h-5 rounded-full text-white " +
                  (completed
                    ? "bg-teal-600"
                    : active
                    ? "bg-white border-2 border-teal-600 text-teal-600"
                    : "bg-white border border-gray-300 text-gray-400")
                }
              >
                {completed ? (
                  <CheckIcon />
                ) : active ? (
                  <span className="w-2.5 h-2.5 rounded-full bg-teal-600" />
                ) : (
                  <span className="w-2.5 h-2.5 rounded-full bg-transparent" />
                )}
              </div>

              {/* vertical connector (not shown for last item) */}
              {!isLast && (
                <div
                  className={
                    "w-px " +
                    (completed ? "bg-gray-400" : "bg-gray-300")
                  }
                  style={{ height: 30 }}
                />
              )}
            </div>
            {/* right column: text */}
            <div className="pb-4 w-full truncate"> 
              <div
                className={
                  "text-sm font-medium truncate" +
                  (completed ? "text-gray-900" : active ? "text-black" : "text-gray-500")
                }
              >
                {label}
              </div>
            </div>
          </div>
        );
      })}
    </nav>
  );
}
